

import { RoutePathNames } from "../helpers/constants";
import { useAppSelector } from "../store/store";
import MainLayout from "../views/MainLayout";
import {Navigate, Route, Routes, useLocation} from 'react-router-dom'
import UserList from "../views/UserList";
import Login from "../views/Login";
import MappingKeys from "../views/MappingKeys";
import ReconciliationRules from "../views/ReconciliationRules";
import Reports from "../views/Reports";
import CostTrialBlance from "../views/CostTrialBalance";
import GeneralTBRecords from "../views/GeneralTBRecords";
import GTBMappingKeys from "../views/GTBMappingKeys";


export function PPTRRoutes() {
    interface ProtectedRouteProps {
        children: React.ReactNode
      }
      
      function ProtectedRoute({ children }: ProtectedRouteProps) {
        const loggedOnUserProfile = useAppSelector(state => state.loggedOnUserProfile.value);
        const location = useLocation();
      
        if (loggedOnUserProfile == null) {
          localStorage.setItem("loginRedirectedFromUrl", location.pathname + location.search);
          return <><Navigate to={"/" + RoutePathNames.LOGIN} replace /></>
        }
        else
          return <>{children}</>
      }
function NoRouteMatch() {
    const location = useLocation();
    return (<div> <h3> No Route match for <code>{location.pathname}</code> </h3> </div>);
  }
    return (
      <Routes>
        
        <Route path={"/"} element={<Login />} />
        <Route path={"/" + RoutePathNames.LOGIN} element={<Login />} />
        <Route element={<MainLayout />}>
        <Route path = {"/" + RoutePathNames.USERS} element={<ProtectedRoute><UserList /></ProtectedRoute>} />
        <Route path = {"/" + RoutePathNames.CTBRECORDS} element={<ProtectedRoute><CostTrialBlance /></ProtectedRoute>} />
        <Route path = {"/" + RoutePathNames.GTBRECORDS} element={<ProtectedRoute><GeneralTBRecords /></ProtectedRoute>} />
        <Route path = {"/" + RoutePathNames.RECONCILIATIONRULES} element={<ProtectedRoute><ReconciliationRules /></ProtectedRoute>} />
        <Route path = {"/" + RoutePathNames.CTBMAPPINGKEYS} element={<ProtectedRoute><MappingKeys /></ProtectedRoute>} />
        <Route path = {"/" + RoutePathNames.GTBMAPPINGKEYS} element={<ProtectedRoute><GTBMappingKeys /></ProtectedRoute>} />
        <Route path = {"/" + RoutePathNames.REPORT_LIST} element={<ProtectedRoute>< Reports/></ProtectedRoute>} />
        
        </Route>
      
        <Route path="*" element={<NoRouteMatch />} />
      </Routes>
    );
  }